import { ServicePageTemplate } from "@/components/ServicePageTemplate";

export default function Nachlassverwertung() {
  return (
    <ServicePageTemplate
      service={{
        title: "Nachlassverwertung",
        keyword: "Nachlassverwertung Berlin",
        metaTitle: "Nachlassverwertung Berlin | Fair & Diskret | MIROS",
        metaDesc:
          "Einfühlsame Nachlassverwertung in Berlin mit fairer Wertanrechnung. Wir sichten, bewerten und räumen diskret.",
        heroSub:
          "Einfühlsame Sichtung und faire Anrechnung von Wertsachen aus dem Nachlass.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9011ee187be68947e2b1.jpg",
        trustImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a900eb2e956bc24f8c799.jpg",
        seoImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a967e20d627a9dcbb.jpg",
        faqImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9017ae7d4768390653f4.jpg",
        trustIntro:
          "Nach einem Todesfall durch die persönlichen Dinge eines geliebten Menschen zu gehen, ist eine der schwersten Aufgaben. Wir unterstützen Sie dabei mit größtem Respekt und Diskretion. Verwertbares rechnen wir fair an, den Rest räumen wir unauffällig.",
        slug: "nachlassverwertung-berlin",
      }}
    />
  );
}
